import type {FC} from 'react';

import {DATE_FORMAT} from '@root/config';
import dayjs from 'dayjs';
import {Observer} from 'mobx-react';

import {i18n, useI18n} from '@yourcoach/i18n';
import {Form} from '@yourcoach/shared/components/Form';
import {GodModeStore} from '@yourcoach/shared/modules/god-mode';
import {useMobxStore} from '@yourcoach/shared/utils/store';

import * as S from './styles';

const renderSetTime = (
  date: Date,
  onDateChange: (date: Date) => void,
  onTimeChange: (date: Date) => void,
) => {
  return (
    <>
      <Form.Section fullWidth isFirst>
        <Form.Label>{i18n.t('shared:date_label')}</Form.Label>
        <Form.TextInput
          defaultValue={dayjs(date).format(DATE_FORMAT)}
          onChange={e => {
            if (!e.payload?.text) {
              return;
            }

            onDateChange(dayjs(e.payload.text).toDate());
          }}
          webProps={{
            min: dayjs(date).format(DATE_FORMAT),
            type: 'date',
          }}
        />
      </Form.Section>
      <Form.Section fullWidth>
        <Form.Label>{i18n.t('shared:time')}</Form.Label>
        <Form.TextInput
          defaultValue={dayjs(date).format('HH:mm')}
          onChange={e => {
            if (!e.payload?.text) {
              return;
            }

            const [hours, minutes] = e.payload?.text.split(':') ?? [0, 0];

            onTimeChange(
              dayjs(date)
                .set('hour', Number(hours))
                .set('minute', Number(minutes))
                .toDate(),
            );
          }}
          webProps={{
            type: 'time',
          }}
        />
      </Form.Section>
    </>
  );
};

export const GodModeButton: FC = () => {
  const {t} = useI18n();
  const store = useMobxStore(() => new GodModeStore(renderSetTime));

  return (
    <Observer>
      {() =>
        store.isActive ? (
          <S.Wrapper onClick={store.showActions}>
            <S.Container>
              <S.Text>
                {`[${t('shared:god_mode')}] ${t('shared:server_time_is')}`}
                <S.TimeContainer>
                  <Observer>
                    {() => <S.Text weight="bold">{store.timeString}</S.Text>}
                  </Observer>
                </S.TimeContainer>
              </S.Text>
              <Observer>
                {() => (store.busy.anyReason ? <S.Spinner /> : null)}
              </Observer>
            </S.Container>
          </S.Wrapper>
        ) : null
      }
    </Observer>
  );
};
